import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Link
} from "react-router-dom";
import { images } from '../../../../settings';

class Tributacao extends Component {
  constructor(props) {
    super(props)
    this.images = images;
  }
  render() {
    return (
      <div className="planos-template">
        <div className="planos-template--risca" style={{backgroundColor: this.props.cor}}></div>
        <div className="planos-template__conteudo">
          <h3 className="h2 h2--500 planos-template__titulo" style={{color: this.props.cor}}>Tributação</h3>
          <h4 className="planos-template__subtitulo">A construção de proposta de simplificação, harmonização e simetria das regras tributárias está ligada aos outros focos de atuação, de modo que não tem ações individuais, mas esteve presente em todas as discussões.</h4>
        </div>
        <div className="planos-template__footer">
          <a className="button button--aylen button--yellow button--border-medium button--size-m button--round-l button--text-thick"
            href="https://www.anbima.com.br/data/files/B5/B5/1F/15/375FE610DC784BE6192BA2A8/Relatorio_de_Iniciativas_2019.pdf "
            target="_blank">
            Saiba mais no Relatório de Iniciativas
          </a>
        </div>
      </div>
    )
  }
}

export { Tributacao }